var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#04AF0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3764 61.617C44.3374 61.6561 44.274 61.6561 44.235 61.617L33.3611 50.7431C33.3223 50.7043 33.2594 50.704 33.2203 50.7425L31.5971 52.3381L29.9752 53.9325C29.9355 53.9714 29.9353 54.0352 29.9745 54.0745L44.235 68.3349C44.274 68.374 44.3374 68.374 44.3764 68.3349L73.0261 39.6853C73.0651 39.6462 73.0651 39.5829 73.0261 39.5439L69.8085 36.3263C69.7695 36.2873 69.7062 36.2873 69.6671 36.3263L44.3764 61.617Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSuccess);
export default __webpack_public_path__ + "static/media/new-success.522d89a629ae24d98a5f21ac312a615f.svg";
export { ForwardRef as ReactComponent };